var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapHospital({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.33333338 12.99999994h9.33333324c.73333333 0 1.33333332-.6 1.33333332-1.33333332v-7.43333326c0-.53333333-.33333333-1.03333332-.86666666-1.23333332l-5.13333328-1.99999998-5.13333328 1.99999998c-.53333333.2-.86666666.7-.86666666 1.23333332v7.43333326c0 .73333333.6 1.33333332 1.33333332 1.33333332z",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.66666666 10.3333333v-1.99999998h1.99999998v-1.33333332h-1.99999998v-1.99999998h-1.33333332v1.99999998h-1.99999998v1.33333332h1.99999998v1.99999998z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapHospital);
export default __webpack_public_path__ + "static/media/map-hospital.e38a4222bf682638dc62d832514d8f0f.svg";
export { ForwardRef as ReactComponent };